import React, { useState, useRef, useContext, useEffect, useMemo } from "react";
import {
    Button,
    Col,
    Container,
    Dropdown,
    DropdownButton,
    FormControl,
    Form,
    Nav,
    Row,
    Tab,
} from "react-bootstrap";
import { Icon } from "@iconify/react";
import overflowMenuVertical from "@iconify-icons/carbon/overflow-menu-vertical";
import sendOutlined from "@iconify-icons/ant-design/send-outlined";
import paperclipIcon from "@iconify-icons/mdi/paperclip";
import ModalDommus from "../../../../../components/Modal";
import ReactTooltip from "react-tooltip";
import { errorToast } from "../../../../../components/DommusToast";
import convertFilesToBase64 from "../../../../../helpers/ConvertFilesToBase64";
import "./input.css";
import {isBrowser, MobileView, BrowserView, isMobile, isTablet} from 'react-device-detect';
import Upload from "./Upload/upload";
import { Galeria } from "../../../../../components/Galeria";
import Swal from "sweetalert2";
import { ChamadoContext } from "../../../../../components/ContextoGlobal";
import { cachearContexto } from "../../../../../helpers/cachearContexto";
import configuracaoService from "../../../../../services/ConfiguracaoService";
import { Editor } from "@tinymce/tinymce-react";
import {faBars, faEnvelope, faPaperclip, faTextHeight} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { networkInterfaces } from "os";
import DommusRequiredSpan from "../../../../../components/DommusRequiredSpan";
import Anexos from "./Anexos";
import { DommusTagsEditor } from "../../../../../components/DommusTagsEditor";
import EmailService from "../../../../../services/EmailService";
import { trackPromise } from 'react-promise-tracker';


export default function Entrada({ onSendMessage, tipoMensagem=null, chamado=null }) {
    const [mensagem, setMensagem] = useState("");
    const [editorTexto, setEditorTexto] = useState(false);  
    const [mensagemAnexos, setMensagemAnexos] = useState("");
    const [openModalUpload, setOpenModalUpload] = useState(false);
    const [openModalEmail, setOpenModalEmail] = useState(false);
    const [destinatarios, setDestinatarios] = useState('');
    const [ccList, setCcList] = useState('');
    const [ccoList, setCcoList] = useState('');
    const [assuntoInput, setAssuntoInput] = useState('');
    const [mensagemInput, setMensagemInput] = useState('');
    const [listaAnexos, setListaAnexos] = useState([]);
    const filesTypes = '*/*';
    const [gruposTags, setGruposTags] = useState({});
    const [assinatura, setAssinatura] = useState('');
    const {limiteCaracteresNotaInterna, emailProponente} = useContext(ChamadoContext);
    const contextoChamados = useContext(ChamadoContext)
    const refInputMenssage = useRef();
    const refInputSection = useRef();

    useEffect(()=>{
        cachearContexto(contextoChamados.limiteCaracteresNotaInterna, contextoChamados.setLimiteCaracteresInternas, configuracaoService.buscarPorChave.bind(configuracaoService, 'limite_caracteres_notas_internas'));
    },[])

    useEffect(() => {
        setAssuntoInput(chamado.motivo.nome);
        setDestinatarios(emailProponente)
    }, []);

    useEffect(() => {
        EmailService.getAssinatura()
            .then((res) => {
                setAssinatura(
                    res.data.assinatura
                        ? JSON.parse(res.data.assinatura)
                        : res.data.assinatura
                );
            })
            .catch((err) => {
                Swal.fire({
                    titleText: "Erro",
                    text: "Houve um problema ao buscar assinatura",
                    icon: "error",
                });
            });
    }, []);
    
    const atualizarQuantidadeLinhasTextarea = () => {
        const textarea = refInputMenssage.current;
        textarea.rows = 1;
        const quantidadeLinhasTextearea = Math.ceil(
            textarea.scrollHeight /
                parseFloat(getComputedStyle(textarea).lineHeight)
        );
        textarea.rows =
            quantidadeLinhasTextearea <= 0 ? 1 : quantidadeLinhasTextearea >= 20 ? 20 : quantidadeLinhasTextearea - 1;
        if (textarea.rows >= 2) {
            textarea.style.borderTopLeftRadius = "10px";
            textarea.style.borderTopRightRadius = "10px";
        } else {
            textarea.style.borderTopLeftRadius = "0";
            textarea.style.borderTopRightRadius = "0";
        }
    };


    const onSubmit = () => {
        
        let mensagemInput = mensagem.trim() ?? null;
        if (mensagemInput && mensagemInput.length) {
            onSendMessage(mensagemInput);
            setMensagem("");
            setEditorTexto(false);
        } else {
            errorToast.fire({ text: "A mensagem não pode estar vazia." });
            setMensagem("");
        }
    };

    useEffect(()=>{
      if(!editorTexto){
        atualizarQuantidadeLinhasTextarea();
      }
    },[editorTexto, mensagem])

    
    const enviarArquivos = async(arquivos)=>{
        if(arquivos.length && mensagemAnexos.length){

            let filesConverter = [];
            let filesLink = [];
            arquivos.forEach((arquivo)=>{
                if(arquivo instanceof File){
                    filesConverter.push(arquivo);
                }else{
                    filesLink.push(arquivo);
                }
            })

            let arquivosConvertidos = await convertFilesToBase64.convertFileToBase64(
                filesConverter
            );
            onSendMessage(mensagemAnexos, [...arquivosConvertidos, ...filesLink]);   
            setMensagemAnexos("");
            setOpenModalUpload(false);                 
        }else{            
            Swal.fire({
                titleText: "Ooops...",
                text: (!arquivos.length ? "Nenhum arquivo para ser enviado!" : "") + (!mensagemAnexos.length ? "Campo de mensagem está vazio" : ""),
                icon: "warning",
            });
        }        
    }

    const handleEditorChange = (content) => {
        setMensagemInput(content);
    }

    const preencherDadosPadraoEmail = () => {
        setDestinatarios(emailProponente || '');
        setAssuntoInput(chamado?.motivo?.nome || '');
    }

    const limparModalEmail = () => {
        setDestinatarios('');
        setCcList('');
        setCcoList('');
        setAssuntoInput('');
        setMensagemInput('');
        setListaAnexos([]);
    }

    const abrirModalEmail = () => {
        preencherDadosPadraoEmail();
        setOpenModalEmail(true);
    }

    const fecharModalEmail = () => {
        limparModalEmail();
        setOpenModalEmail(false);
    }

    const handleSubmitForm = async () => {
        const to = (destinatarios && destinatarios.trim()) || emailProponente || '';
        if (!to || !to.length) {
            Swal.fire({ titleText: 'Ooops...', text: 'Campo "Para" é obrigatório', icon: 'warning' });
            return;
        }
        if (!mensagemInput || !mensagemInput.trim().length) {
            Swal.fire({ titleText: 'Ooops...', text: 'Mensagem não pode estar vazia', icon: 'warning' });
            return;
        }

        const dados = new FormData();

        dados.append('to', to);
        dados.append('cc', ccList || '');
        dados.append('bcc', ccoList || '');
        dados.append('subject', assuntoInput || '');
        dados.append('footer', mensagemInput || '');
        dados.append('id_ticket', chamado?.id_ticket || '');

        if (listaAnexos?.length) {
            listaAnexos.forEach(arquivo => {
                dados.append('attachments[]', arquivo);
            });
        }

        try {
            await trackPromise(EmailService.enviarEmail(dados, true));
            Swal.fire({ titleText: 'Sucesso', text: 'E-mail enviado com sucesso', icon: 'success' });
            fecharModalEmail();
        } catch (error) {
            let message = error.response.data.mensagem ?? "Ocorreu um erro ao enviar o e-mail"
            Swal.fire({ titleText: 'Erro', text: message, icon: 'error' });
        }
    }
    
    useEffect(() => {
        if (openModalEmail) {
            const defaultEmail = emailProponente || '';
            setDestinatarios(defaultEmail);
        }
    }, [openModalEmail, emailProponente, chamado]);

    const DropdownOptions = ({className = 'btn-options', tamanho = 'sm'}) => {
        return (<DropdownButton
            className={className}
            id="dropMenuOpcoes"
            size={tamanho}
            title={<Icon icon={overflowMenuVertical} />}
        >
            <Dropdown.Item
                className="opcaoMenu"
                onClick={() => {
                    setOpenModalUpload(true);
                }}
            >
                <div className="item-menu opcao-enviar-arquivo">
                    <FontAwesomeIcon icon={faPaperclip} width="1.1rem" color="black"/>
                    <span className="tituloEnviarImagem">
                        Imagens & Anexos
                    </span>
                </div>
            </Dropdown.Item>
            <Dropdown.Item
                className="opcaoMenu"
                onClick={() => {
                    abrirModalEmail();
                }}
            >
                <div className="item-menu opcao-enviar-arquivo">
                    <FontAwesomeIcon icon={faEnvelope} width="1.1rem" color="black"/>
                    <span className="tituloEnviarImagem">
                        Novo E-mail
                    </span>
                </div>
            </Dropdown.Item>
        </DropdownButton>)
    }

    const novasOpcoes = {
        language: "pt_BR",
        entity_encoding: "raw",
        selector: "textarea#default-editor",
        statusbar: false,
        menubar:false,
        height: 100,

        toolbar:
        "formatselect | bold italic",
        plugins: ['quickbars'],
        content_style:
          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px; border: none }",
        
      };

    const mceOpcoes = {
        selector: '.tinymce-body',
        menubar: false,
        plugins: [
          'link',
          'lists',
          'autolink',
          'quickbars'
        ],
        height: 300,
        toolbar: [
          'undo redo | bold italic underline'
        ],
        valid_elements: 'p[style],strong,em,span[style],a[href],ul,ol,li',
        valid_styles: {
          '*': 'font-size,font-family,color,text-decoration,text-align'
        },
      }   

    const btnOpenEditor = useMemo(()=>{
      return(
        <button
          className={`btn btn-open-editor mr-2 ${editorTexto ? 'ativo' : ''}`}
          data-tip={`${editorTexto ? "Fechar" : "Abrir"} editor de texto`}
          onClick={()=>{
            setEditorTexto((current) => !current);
          }}
        >
          <FontAwesomeIcon icon={faTextHeight}/>
        </button>
      )
    }, [editorTexto])

    return (
        <>
            <ReactTooltip />
            <div id="Input" ref={refInputSection}>
              {!editorTexto && btnOpenEditor }
              {!editorTexto && <DropdownOptions />}
              {editorTexto ?  
                <div className="editor-message-field">
                  <Editor
                      ref={refInputMenssage}
                      tinymceScriptSrc='/tinymce/tinymce.min.js'
                      licenseKey='gpl'
                      onEditorChange={(e) => {
                        if(tipoMensagem === 'notas_internas'){
                          if (e.length <= limiteCaracteresNotaInterna?.valor) {
                            setMensagem(e);
                          }else{
                            let newTexto = e.slice(0, limiteCaracteresNotaInterna?.valor);
                            setMensagem(newTexto);
                          }
                        }else{
                            setMensagem(e);
                        }
                      }} 
                      value={mensagem}
                      init={mceOpcoes}
                  />
                </div> :
                <FormControl
                    className="input-message-field"
                    aria-label="Mensagens"
                    ref={refInputMenssage}
                    value={mensagem ?? ""}
                    placeholder="Mensagem"
                    as="textarea"
                    autoFocus={true}
                    rows={1}
                    onChange={(e) => {
                        if (e.target.value.length <= limiteCaracteresNotaInterna?.valor) {
                            atualizarQuantidadeLinhasTextarea();
                            setMensagem(e.target.value);
                        }
                    }}          
                    onFocus={()=>{
                        if(refInputSection.current){
                            if(isTablet){
                                refInputSection.current.style.paddingBottom = "10px";
                            }
                            else if(isMobile){
                                refInputSection.current.style.paddingBottom = "20px";
                            }
                        }
                    }}
                    onBlur={()=>{
                        if(isMobile || isTablet){
                            if(refInputSection.current){
                                refInputSection.current.style.paddingBottom = "0";
                            }
                        }
                    }}   
                /> }

              {!editorTexto &&  <Button
                  data-tip="Enviar mensagem"
                  className="btn-send"
                  onClick={() => {
                      onSubmit();
                  }}
              >
                  <Icon icon={sendOutlined} color="white" />
              </Button>}
            </div>

            {editorTexto && 
            <span className="group-options-editor">
                {btnOpenEditor}
                <DropdownOptions className={'dropdown-button-editor'} tamanho="lg"/>
                <Button
                    data-tip="Enviar mensagem"
                    className="editor-enviar-button"
                    onClick={() => {
                        onSubmit();
                    }}
                >
                    Enviar <Icon icon={sendOutlined} color="white" />
                </Button>
            </span>}

            <ModalDommus
                titulo="Imagens & Anexos"
                size="lg"
                open={openModalUpload}
                close={() => {
                    setOpenModalUpload(false);
                }}
            >
                <Container fluid>
                    <Tab.Container defaultActiveKey="direto">
                        <Row>
                            <Col xs={12} md={12}>
                                <Nav fill variant="tabs">
                                    <Nav.Item>
                                        <Nav.Link eventKey="direto">
                                            {(isBrowser && "Envio ") || ""}
                                            Direto
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="imagens">
                                            {(isBrowser && "Galeria de ") || ""}
                                            Imagens
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="anexos">
                                            {(isBrowser && "Galeria de ") || ""}
                                            Arquivos
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Col>
                            <Col xs={12} md={12}>
                                <Tab.Content>
                                    <Tab.Pane eventKey="direto">
                                        <div className="px-3 py-3 border rounded">
                                            <Upload
                                                mensagem={mensagemAnexos}
                                                setMensagemInput={setMensagemAnexos}
                                                enviarImagem={enviarArquivos}
                                                setOpenModalUpload={
                                                    setOpenModalUpload
                                                }
                                            />
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="imagens">
                                        <BrowserView className="px-3 py-3 border rounded">
                                            <Galeria
                                                tipo="imagem"
                                                definirEstadoModal={
                                                    setOpenModalUpload
                                                }
                                                enviarArquivos={enviarArquivos}
                                                mensagem={mensagemAnexos}
                                                setMensagem={setMensagemAnexos}
                                            />
                                        </BrowserView>
                                        <MobileView>
                                            <Galeria
                                                tipo="imagem"
                                                definirEstadoModal={
                                                    setOpenModalUpload
                                                }
                                                enviarArquivos={enviarArquivos}
                                                mensagem={mensagemAnexos}
                                                setMensagem={setMensagemAnexos}
                                            />
                                        </MobileView>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="anexos">
                                        <BrowserView className="px-3 py-3 border rounded">
                                            <Galeria
                                                tipo="anexo"
                                                definirEstadoModal={
                                                    setOpenModalUpload
                                                }
                                                enviarArquivos={enviarArquivos}
                                                mensagem={mensagemAnexos}
                                                setMensagem={setMensagemAnexos}
                                            />
                                        </BrowserView>
                                        <MobileView>
                                            <Galeria
                                                tipo="anexo"
                                                definirEstadoModal={
                                                    setOpenModalUpload
                                                }
                                                enviarArquivos={enviarArquivos}
                                                mensagem={mensagemAnexos}
                                                setMensagem={setMensagemAnexos}
                                            />
                                        </MobileView>
                                    </Tab.Pane>
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>
                </Container>
            </ModalDommus>

            <ModalDommus
                titulo="Novo E-mail"
                size="lg"
                open={openModalEmail}
                close={() => {
                    fecharModalEmail();
                }}
            >
                <Container fluid>
                    <Form.Group as={Row} controlId="formPara">
                        <Form.Label column sm="1">
                            Para:
                            <DommusRequiredSpan />
                        </Form.Label>
                        <Col sm="11">
                            <Form.Control
                                type="email"
                                placeholder="email@dominio.com"
                                value={destinatarios}
                                onChange={(event) => setDestinatarios(event.target.value)}
                            />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="formCC">
                        <Form.Label column sm="1">
                            CC:{" "}
                        </Form.Label>
                        <Col sm="11">
                            <Form.Control
                                type="text"
                                value={ccList}
                                onChange={(e) => setCcList(e.target.value)}
                            />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="formCCO">
                        <Form.Label column sm="1">
                            CCO:{" "}
                        </Form.Label>
                        <Col sm="11">
                            <Form.Control
                                type="text"
                                value={ccoList}
                                onChange={(e) => setCcoList(e.target.value)}
                            />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="formAssunto">
                        <Form.Label column sm="1">
                            Assunto:
                            <DommusRequiredSpan />
                        </Form.Label>
                        <Col sm="11">
                            <Form.Control
                                type="text"
                                placeholder="Digite o Assunto"
                                value={assuntoInput}
                                onChange={(event) => setAssuntoInput(event.target.value)}
                                disabled={false}
                            />
                        </Col>
                    </Form.Group>
                    <Form.Group controlId="formMensagem">
                        <Form.Label>Anexos:</Form.Label>
                        <Anexos listaAnexos={listaAnexos} setListaAnexos={setListaAnexos} filesTypes={filesTypes} formData={true} />
                    </Form.Group>
                    <Form.Group controlId="formMensagem">
                        <Form.Label>
                            Mensagem: <DommusRequiredSpan />
                        </Form.Label>
                        <div className="editor-email-section">
                            <DommusTagsEditor
                                handleEditorChange={handleEditorChange}
                                conteudo={mensagemInput || ''}
                                gruposTags={gruposTags}
                                utilizarDommusTag={false}
                                assinatura={assinatura}
                            />
                        </div>
                    </Form.Group>
                    <Button
                        type="submit"
                        className="btnEnviarEmail"
                        onClick={() => {
                            handleSubmitForm();
                        }}
                    >
                        Enviar
                    </Button>
                </Container>
            </ModalDommus>
        </>
    );
}
